<template>
    <div>
        <div class='about-bg'>
            <el-image :src="about_header" style=" width: 100%; margin-bottom: 3%"></el-image>
            <div class="about-item">
<!--              <el-image v-show="$i18n.locale==='zh'" :src="about_content" class="about-item-zh" style="width: 64%"></el-image>-->
              <el-image v-show="$i18n.locale==='en'" v-for="item in about_content" :src="item" :key="item" class="about-item-zh" style="width: 64%"></el-image>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data(){
    return {
      about_header: `${require('../assets/images_new/head_about.jpg')}`,
      about_content: [
          `${require('../assets/images_new/new_about1.png')}`,
          `${require('../assets/images_new/new_about2.jpg')}`,
          `${require('../assets/images_new/new_about3.png')}`,
          `${require('../assets/images_new/new_about5.png')}`,
          `${require('../assets/images_new/new_about6.png')}`,
          `${require('../assets/images_new/new_about4.png')}`,

      ]

    }
  },
  computed: {
    about_content_en() {
      return false;
    },
  },
}
</script>

<style>
.about-item {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 50px;
}
.about-item-zh {
  width: 100%;
  /*margin-bottom: 3%*/
}
.about-item-en {
  width: 100%;
  /*margin-bottom: 3%*/
}
@media screen and (max-width: 926px) {
  .about-item {
    margin-top: 20px;
    width: 110%;
    right: 5%;
    position: relative;
  }
  .about-item-en {
    width: 70%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/About.vue